import { useDispatch } from 'react-redux'
import { triggerWidgetOpenCloseEvent } from 'app/utils/event.js'
import { setShowLuancher } from 'app/redux/widget/widget.actions'
import { Close } from 'app/components/icons'
import styles from './styles.module.scss'

function CloseWidgetBtn() {
  const dispatch = useDispatch()

  const handleCloseBtnClick = () => {
    dispatch(setShowLuancher(false))
    triggerWidgetOpenCloseEvent(false)
  }

  return (
    <div className={styles.chat_header_close_icon} onClick={handleCloseBtnClick}>
      <Close color="#ffffff" />
    </div>
  )
}

export default CloseWidgetBtn
